import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import { lessonUses } from '../data/lessons';
export function LessonsSection() {
  return <section className="py-20 px-4 bg-primary tech-grid" data-id="element-136" data-mp="2wmi20b8d7bl0">
      <motion.div initial={{
      opacity: 0,
      y: 16
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.3,
      ease: [0.23, 1, 0.32, 1]
    }} className="max-w-4xl mx-auto text-center" data-id="element-137" data-mp="2wn1hzmegfpwe">
        <h2 className="text-3xl md:text-4xl font-display font-bold uppercase text-white mb-6" data-id="element-138" data-mp="3kbkhpdjfuucv">
          🎯 <span className="text-accent" data-id="element-139" data-mp="3fku97rfpubdy">150 READY-TO-TEACH</span> AUTOMOTIVE TECHNOLOGY LESSONS
        </h2>
        <p className="text-xl text-white/80" data-id="element-140" data-mp="3an2kt7ea57ei">Stop asking:</p>
        <p className="text-2xl md:text-3xl font-display font-bold text-accent mt-2 mb-6" data-id="element-141" data-mp="3akgbp3bqqju6">
          “What am I going to teach tomorrow?”
        </p>
        <p className="text-lg text-white/80 max-w-3xl mx-auto mb-10" data-id="element-142" data-mp="74j0cr1uf5u9">
          Across the complete 6-in-1 system, you receive 150 ready-to-teach Automotive Technology
          lessons covering the major areas instructors work with throughout an Automotive
          Technology program.
        </p>

        <div className="bg-white rounded-xl border-2 border-accent p-6 md:p-8 text-left" data-id="element-143" data-mp="m91sh0c21fct">
          <p className="text-sm font-bold text-secondary uppercase tracking-wider mb-4" data-id="element-144" data-mp="r8eexjz0kkev">
            Use them for:
          </p>
          <ul className="grid sm:grid-cols-2 md:grid-cols-3 gap-x-6 gap-y-3" data-id="element-145" data-mp="cadnb2564uqj">
            {lessonUses.map(use => <li key={use} className="flex items-start gap-2 text-sm text-body" data-id="element-146" data-mp="h8nfr4zidh8g">
                <CheckCircle2 size={16} className="text-secondary shrink-0 mt-0.5" data-id="element-147" data-mp="3d36z2dhufer" />
                <span data-id="element-148" data-mp="8avbqwz8lw0d">{use}</span>
              </li>)}
          </ul>
          <p className="text-primary font-semibold text-sm mt-6 pt-4 border-t border-primary/10" data-id="element-149" data-mp="1xqb8fcvz5p9d">
            Each lesson is designed to be structured, practical and easy to follow.
          </p>
        </div>

        <p className="text-lg font-display font-bold tracking-wide text-white mt-8" data-id="element-150" data-mp="20ahbzjgofdpe">
          Open the lesson. Review the visual material. Prepare the demonstration.{' '}
          <span className="text-accent" data-id="element-151" data-mp="1r8htsntxe3kv">Teach.</span>
        </p>
      </motion.div>
    </section>;
}